export default class PlanType {
  external_id_name: string;
  key: string;
  display_name: string;
}
